<template>
    <div>
      <div class="col-md-3 col-xs-12">
        <va-small-box
          class="info-box box-blue"
          icon="ion-briefcase "
          :title="totalCollectionAmt"
          description="Total Collection Amount"
          @more-click="clickToSmallBox"
          moreText="More info">
        </va-small-box>
      </div>
    </div>
</template>
<script>
import VASmallBox from '../widgets/VASmallBox.vue'
export default {
  props: ['message'],
  data () {
    return {
      totalCollection: 0,
      totalInterest: 0
    }
  },
  computed: {
    totalCollectionAmt () {
      if (this.message[0]) {
        this.totalCollection = this.message[0].totalCollection
      }
      return this.totalCollection
    }
  },
  methods: {
    clickToSmallBox () {
      this.$router.push({name: 'showCollection'})
    }
  },

  components: {
    'va-small-box': VASmallBox
  }
}
</script>
<style >
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-blue {
    background-color:#003c60;
    color: #fff;
  }
   /* .iconColor {
    color: rgb(12, 156, 55);
  } */
  /* .small-box > .small-box-footer {
  background: rgb(12, 156, 55);
} */
</style>



// WEBPACK FOOTER //
// totalcollection.vue?dc6052ca